import consumer from "./consumer";

consumer.subscriptions.create("NotificationChannel", {
  connected() {},

  disconnected() {},

  received(data) {
    const notifications = document.getElementById("flash_messages");
    if (notifications) {
      if (data && typeof data.html === "string") {
        notifications.insertAdjacentHTML("beforeend", data.html);
      } else {
        console.error(
          "Received notification data is missing 'html' property or is not a string."
        );
      }
    } else {
      console.error(
        "Notifications container not found! Make sure element with id='flash_messages' exists"
      );
    }
  },
});
